import collection from "../utils/collection";
import Product from "./product";

let closestPages;

let setPages = (index, lastPage, currentPage) => {
    let minValue = index;
    let maxValue = lastPage.number - (5 - index);
    let placeOnView = index - 3;
    let currentValue = currentPage.number + placeOnView;

    maxValue = (maxValue <= index) ? index : maxValue;

    if(currentValue > minValue){

        if(currentValue < maxValue){
            closestPages[index-1] = {number:currentValue};
        } else {
            closestPages[index-1] = {number:maxValue};
        }

    } else {
        closestPages[index-1] = {number:minValue};
    }
};

export default {
    fillPagination: function(lastPage, currentPage){
        let numPages = (lastPage.number > 5) ? 5 : lastPage.number;

        closestPages = [];

        for(let i=1; i <= numPages; i++){
            setPages(i, lastPage, currentPage);
        }

        return closestPages;
    },

    getLastNumber:function (totalProductsNumber, currentNumPerPage) {
        return Math.ceil(totalProductsNumber/currentNumPerPage.value);
    },

    getCurrentNumPerPage: function(){
        let localStorageValue = localStorage.getItem('productsPerPage');
        let productsPerPage = localStorageValue ? JSON.parse(localStorageValue) : this.numbersPerPage[2];

        return productsPerPage;
    },
    setCurrentNumPerPage: function(value){
        localStorage.setItem('productsPerPage', JSON.stringify(value));
    },
    getDefaultSortItem: function(){
        return this.sortList[0];
    },
    getDefaultPage: function(){
        return {number:1};
    },
    getInitialPages: function (maxPages) {
        let pages = [];

        for(let i = 1; i < 6; i++){
            if(maxPages >= i){
                pages.push({number:i});
            }
        }

        return pages;
    },
    paginationArrowClick: function (scope, type) {
        if((type === 'prev') && (scope.currentPage.number !== 1)){
            scope.currentPage.number -= 1;
            this.fillPagination(scope.lastPage, scope.currentPage);

        } else if((type === 'next') && scope.currentPage.number !== scope.lastPage.number){
            scope.currentPage.number += 1;
            this.fillPagination(scope.lastPage, scope.currentPage);
        }
    },
    getStarImage: function (stars, indexCurrentStar) {
        let urlToReturn;
        if((stars < indexCurrentStar) && (stars >= (indexCurrentStar - 0.5))){
            urlToReturn = window.env.baseUrl + '/svg/icons.svg#icon-star-half';
        } else if(stars < indexCurrentStar){
            urlToReturn = window.env.baseUrl + '/svg/icons.svg#icon-star-outlined';
        } else {
            urlToReturn = window.env.baseUrl + '/svg/icons.svg#icon-star-filled';
        }

        return urlToReturn;
    },
    getCurrentUser: function () {
        let promise = new Promise((resolve, reject) => {
            $.get('/?action=user/current',{}).then( function (response) {
               resolve(response);
            }).catch(function () {
                reject();
            })
        });

        return promise;
    },
    sortList:[
        {
            name:'popularity',
            title:'Popularity',
            paramName: 'sortBy[popularity]',
            paramValue: 'desc'
        },
        {
            name:'desc',
            title:'Price: High to Low',
            paramName: 'sortBy[price]',
            paramValue: 'desc'
        },
        {
            name:'asc',
            title:'Price: Low to High',
            paramName: 'sortBy[price]',
            paramValue: 'asc'
        }
    ],
    numbersPerPage: [
        {
            value:20
        },
        {
            value:40
        },
        {
            value:60
        },
        {
            value:100
        }
    ]
}
